module.exports = __webpack_public_path__ + "static/media/icon-payroll.fa09f5d5.svg";